export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <p>© 2026 Integrated Office Infrastructure Pvt. Ltd. All rights reserved.</p>
        <p>Complete IT Solution Company</p>
      </div>
    </footer>
  );
}